import React from 'react';
import { Layout } from '../components/Layout';
export function Legal() {
  return <Layout data-id="element-512">
      <div className="max-w-3xl mx-auto px-4 py-16" data-id="element-513">
        <h1 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-514">
          Términos y Condiciones
        </h1>
        <div className="prose prose-gray max-w-none" data-id="element-515">
          <p className="text-gray-600 mb-4" data-id="element-516">
            Bienvenido a Agreexa™. Al utilizar nuestros servicios, aceptas
            estos términos y condiciones.
          </p>
          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4" data-id="element-517">
            1. El Servicio
          </h2>
          <p className="text-gray-600 mb-4" data-id="element-518">
            Agreexa provee una plataforma de acuerdos seguros (escrow) para
            proteger transacciones comerciales entre prestadores de servicios y
            clientes.
          </p>
          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4" data-id="element-519">
            2. Responsabilidades
          </h2>
          <p className="text-gray-600 mb-4" data-id="element-520">
            Agreexa retiene los fondos de manera segura hasta que ambas partes
            confirmen la finalización del acuerdo. No somos responsables por la
            calidad del servicio prestado.
          </p>
          {/* Placeholder for full legal text */}
        </div>
      </div>
    </Layout>;
}